import tunnels from './tunnels.js'

function alphabetical (a, b) {
  if ((a.sortAs || a.country) < (b.sortAs || b.country)) {
    return -1
  }
  if ((a.sortAs || a.country) > (b.sortAs || b.country)) {
    return 1
  }
  return 0
}

tunnels.sort(alphabetical)

tunnels.unshift({
  code: 'fast',
  country: 'Fastest'
})

export default {
  main: {
    copy: 'How can we help?',
    type: 'radio',
    options: {
      account: { copy: 'I\'m having an issue with my subscription, payments, or account' },
      functionality: { copy: 'My TunnelBear doesn\'t work properly' },
      feedback: { copy: 'I have a general question, feedback or a feature request' }
    }
  },
  mainDetails: {
    account: {
      copy: 'What\'s the problem?',
      type: 'radio',
      options: {
        confirm: {
          copy: 'I can\'t confirm my email',
          followups: ['describeIssue']
        },
        billing: {
          copy: 'There\'s been a billing error',
          followups: ['describeIssue']
        },
        cancel: {
          copy: 'I\'d like to cancel my subscription',
          followups: ['describeIssue']
        },
        delete: {
          copy: 'I want to delete my account',
          followups: ['describeIssue']
        }
      }
    },
    functionality: {
      copy: 'What\'s the problem?',
      type: 'radio',
      options: {
        connection: {
          copy: 'I can\'t connect TunnelBear',
          followups: ['describeIssue', 'device', 'os', 'services', 'location', 'network', 'tunnelConnect']
        },
        installation: {
          copy: 'I can\'t install TunnelBear',
          followups: ['describeIssue', 'device', 'os', 'services']
        },
        crashing: {
          copy: 'The TunnelBear app is crashing',
          followups: ['describeIssue', 'device', 'os', 'services']
        },
        speed: {
          copy: 'My connection is slow',
          followups: ['location', 'network', 'device', 'services', 'tunnelSlow']
        },
        access: {
          copy: 'I can\'t access certain sites or services while using TunnelBear',
          followups: ['blocked', 'describeIssue']
        }
      }
    },
    feedback: {
      copy: 'What\'s the problem?',
      type: 'radio',
      options: {
        request: {
          copy: 'I have a feature request',
          followups: ['featureRequest']
        },
        country: {
          copy: 'I have a country request',
          followups: ['countryRequest']
        },
        feedback: {
          copy: 'I have some feedback for the Bears',
          followups: ['describe']
        },
        question: {
          copy: 'I have a general question for the Bears',
          followups: ['describe']
        }
      }
    }
  },
  followups: {
    describeIssue: {
      copy: 'Please describe the issue in detail',
      type: 'textarea'
    },
    describe: {
      copy: 'Please share your thoughts below',
      type: 'textarea'
    },
    device: {
      copy: 'What kind of device are you using?',
      type: 'radio',
      options: ['Windows', 'Mac', 'iPhone / iPad', 'Android', 'Browser extension']
    },
    os: {
      copy: 'What operating system is running on this device?',
      type: 'text'
    },
    services: {
      copy: 'Are you using any other privacy/security services (other VPNs, proxies, firewall, antivirus, etc.)?',
      type: 'radio',
      options: ['Yes', 'No', 'Don\'t know'],
      additionalInput: {
        'Yes': 'Please specify:'
      }
    },
    location: {
      copy: 'What country are you physically located in?',
      type: 'text'
    },
    network: {
      copy: 'What kind of network are you using?',
      type: 'radio',
      options: ['Home Wifi', 'Public Wifi', 'Cellular / Mobile Data', 'Wired']
    },
    tunnelConnect: {
      copy: 'Which tunnel are you trying to connect to?',
      type: 'dropdown',
      options: tunnels
    },
    tunnelSlow: {
      copy: 'Which tunnel is performing slowly?',
      type: 'dropdown',
      options: tunnels
    },
    blocked: {
      copy: 'Which website or service is blocked while TunnelBear is on?',
      type: 'text'
    },
    countryRequest: {
      copy: 'What country would you like to connect to?',
      type: 'text'
    },
    featureRequest: {
      copy: 'What feature would you like to see?',
      type: 'textarea'
    }
  }
}
